import PropTypes from 'prop-types';

export const props = {
  show: PropTypes.bool,
};
